<template>
  <div id="home-page" class="wide content">
    <div class="main-files">
      <h3>Search Results</h3>
      <div class="toolbox">
        <a href="#" @click.prevent="goBack"><i class="fas fa-arrow-left fa-fw" />Back</a>
      </div>
      <div class="file-list">
        <template v-if="searchResults && searchResults.length > 0">
          <div class="item" v-for="item in searchResults" :key="item.id">
            <template v-if="item.filename == '.'">
              <router-link :to="`/${item.id}`">
                <img src="../assets/small-folder.png" alt="folder">
                {{ item.display_name }}
              </router-link>
            </template>
            <template v-else>
              <a href="javascript:void(0)" @click.prevent.stop="download(item)">
                <img src="../assets/pdf-icon.png" alt="file">
                {{ item.display_name }}
              </a>
            </template>
          </div>
        </template>
        <template v-if="searchResults && searchResults.length == 0">
          No results found.                    
        </template>
      </div>
    </div>
    <div class="quick-files">
      <h3>My Portfolio</h3>
      <portfolio />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Portfolio from '../components/Portfolio.vue'

import {mapState} from 'vuex'

export default {
  name: 'SearchResults',
  components: {Portfolio},
  data() {
    return {
    }
  },
  computed: {
    ...mapState(['searchResults']),
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async download(item) {
      window.open(`/api/files/download/${item.id}`, '_blank')
    },
  },
}
</script>
<style lang="scss">
@import '../scss/include-media';

</style>
